/*jshint esversion:6 */
import React from 'react';
import { CookiesProvider, Cookies } from 'react-cookie';
import Constants from '../../../../configurations/constants';
import Messages from '../../../../configurations/messages';
import Permissions from '../../../../configurations/permissions';
import Util from '../../../../util/util'; 
import {Permissioned} from 'react-permissions';
import {connect} from 'react-redux';

class SettlementModalActions extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedAction: null,
            neverAsk: false
        };
        this.cookies = new Cookies();
    }



    handleActionClick(actionObject) {
        let cookies  = this.cookies;
        if (cookies.get(`${Constants.COOKIE_PREFIX_NEVER_ASK}${actionObject.action}`)) {
            actionObject.handler(actionObject);
        }
        else {
            if (!this.state.selectedAction) {
                this.setState({ selectedAction: actionObject });
            } else {
                if (this.state.neverAsk) {
                    cookies.set(`${Constants.COOKIE_PREFIX_NEVER_ASK}${actionObject.action}`, "true", { path: "/" });
                }
                actionObject.handler(actionObject);

            }
        }

    }


    render() {
        return (
            <CookiesProvider>
                <div>
                    {
                        !this.state.selectedAction &&
                        <div className="dispute-modal-actions">
                            {
                                //Sort and Render Action Buttons
                                this.props.actions && !this.state.selectedAction && this.props.actions.map((actionObject) => {
                                   
                                    return <button key={actionObject.action} onClick={(evt) => { this.handleActionClick(actionObject) }} disabled={this.props.disabled} className="btn btn-primary">{actionObject.action}</button>
                                })

                            }

                            {
                                this.props.hasCancel && this.props.cancelHandler && <button onClick={(evt) => { this.props.cancelHandler(evt) }} disabled={this.props.disabled} className="btn btn-danger">CLOSE</button>
                            }
                        </div>
                    }
                    {
                        this.state.selectedAction &&
                        <div className="mod-footer">
                            <div className="action-warning">
                               {Messages.ACTION_WARNING} "<strong>{this.state.selectedAction.action}</strong>" ?
                            </div>
                            <div className="mod-footer-buttons">
                                <button onClick={(evt) => { this.setState({ neverAsk: false, selectedAction: null }) }} disabled={this.props.disabled} className="btn btn-danger">NO</button>
                                <button onClick={(evt) => { this.handleActionClick(this.state.selectedAction) }} disabled={this.props.disabled} className="btn btn-primary">YES</button>
        
                            </div>
                             <div className="checkbox never-ask">
                                <label>
                                    <input type="checkbox" onChange={(event) => { this.setState({ neverAsk: event.target.checked }) }} />
                                    <span className="lbl">{Messages.ACTION_NEVER_ASK}</span>
                                </label>
                            </div>

                        </div>
                    }
                </div>
            </CookiesProvider>
        );
    }
};

export default connect(Util.defaultMapStateToProps)(Permissioned(SettlementModalActions, [
    Permissions.VIEW_SETTLEMENT, 
    Permissions.VIEW_SETTLEMENT_REQUEST, 
    ]));


// WEBPACK FOOTER //
// ./src/components/settlement/settlementRequests/modal/settlementModalAction.js